import { registerLocaleData } from "@angular/common";
import {
	HttpClient,
	provideHttpClient,
	withInterceptorsFromDi
} from "@angular/common/http";
import localeIt from "@angular/common/locales/it";
import { APP_INITIALIZER, NgModule } from "@angular/core";
import {
	LuxonDateAdapter,
	LuxonDateModule,
	MAT_LUXON_DATE_FORMATS
} from "@angular/material-luxon-adapter";
import {
	DateAdapter,
	ErrorStateMatcher,
	MAT_DATE_FORMATS,
	MAT_DATE_LOCALE,
	ShowOnDirtyErrorStateMatcher
} from "@angular/material/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { authConfig, environment } from "@app/../environments/environment";
import { AppRouterModule } from "@app/app-router.routing";
import { AppComponent } from "@app/app.component";
import { CoreModule } from "@app/core/core.module";
import { LoginGuard } from "@app/guard/login.guard";
import { NewUserGuard } from "@app/guard/new-user.guard";
import { PrivateModule } from "@app/private/private.module";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { StorageManagerService } from "@shared/services/storage/storage-manager.service";
import { SharedModule } from "@shared/shared.module";
import { TranslateSessionLoader } from "@shared/translate-session.loader";
import { OAuthModule, OAuthService } from "angular-oauth2-oidc";

registerLocaleData(localeIt);
export const translateLoader = (
	http: HttpClient,
	storageService: StorageManagerService
) =>
	new TranslateSessionLoader(
		http,
		storageService,
		environment.translatePrefix,
		".json"
	);

/* export function initializeAuth(oauthService: OAuthService) {
	return () => {
		oauthService.configure(authConfig);
		// load discovery document and try login
		return oauthService.loadDiscoveryDocumentAndTryLogin().then(() => {
			// // Imposta refresh automatico
			// oauthService.setupAutomaticSilentRefresh();
		});
	};
} */

export function initializeAuth(oauthService: OAuthService) {
	return async () => {
		const publicPaths = ["/password-recovery", "/user-signup", "/paymentSuccess", "/change-password", "/maintenance"], // le tue rotte pubbliche
			currentPath = window.location.pathname,
			isPublicRoute = publicPaths.some(path => currentPath.startsWith(path));

		oauthService.configure(authConfig);
		oauthService.setupAutomaticSilentRefresh(undefined, "access_token");
		await oauthService.loadDiscoveryDocumentAndTryLogin();

		if (!isPublicRoute && !oauthService.hasValidAccessToken()) {
			oauthService.initCodeFlow();
		}
	};
}


@NgModule({
	declarations: [AppComponent],
	bootstrap: [AppComponent],
	imports: [
		BrowserAnimationsModule,
		BrowserModule,
		TranslateModule.forRoot({
			loader: {
				provide: TranslateLoader,
				useFactory: translateLoader,
				deps: [HttpClient, StorageManagerService]
			}
		}),
		SharedModule,
		CoreModule,
		PrivateModule,
		LuxonDateModule,
		OAuthModule.forRoot({
			resourceServer: {
				allowedUrls: [
					environment.baseApiUrl,
					environment.k8sApiUrl
				],
				sendAccessToken: true
			}
		}),
		AppRouterModule
	],
	providers: [
		{
			provide: APP_INITIALIZER,
			useFactory: initializeAuth,
			deps: [OAuthService],
			multi: true
		},
		LoginGuard,
		NewUserGuard,
		{ provide: ErrorStateMatcher, useClass: ShowOnDirtyErrorStateMatcher },
		{ provide: MAT_DATE_LOCALE, useValue: "it-IT" },
		{
			provide: DateAdapter,
			useClass: LuxonDateAdapter,
			deps: [MAT_DATE_LOCALE]
		},
		{ provide: MAT_DATE_FORMATS, useValue: MAT_LUXON_DATE_FORMATS },
		provideHttpClient(withInterceptorsFromDi())
	]
})
export class AppModule { }